import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	liveDoc: {
		id: 'live_doc_type',
		defaultMessage: 'Live Doc',
		description: 'Type text for live document',
	},
	workItem: {
		id: 'work_item',
		defaultMessage: 'Work item',
		description: 'Label for work item in recent activity',
	},
	draftLabel: {
		id: 'draft_label',
		defaultMessage: 'DRAFT',
		description: 'Lozenge label for draft results',
	},
});
